import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Drawer, List, Tag } from "antd";

const TIPOS_NODO = {
  entrada: "Entrada",
  salida: "Salida",
  interseccion: "Intersección",
  inicio_pasillo: "Inicio de pasillo",
  fin_pasillo: "Fin de pasillo",
  punto_intermedio: "Punto intermedio",
  acceso_ubicaciones: "Acceso a ubicaciones",
  estacion: "Estación de surtido",
  puerta: "Puerta",
  rampa: "Rampa",
  elevador: "Elevador",
  transicion_seccion: "Transición entre secciones",
};

//Drawer de solo lectura para un nodo de circulación, abierto con doble clic desde LienzoMapaWms.js -
//muestra su información básica y qué racks se alcanzan desde ahí (mismo endpoint que ya usa la versión
//editable de este panel dentro del editor de mapa, ver PanelPropiedadesNodo.js).
const NodoDetalleDrawer = ({ visible, onClose, nodo, headersToken }) => {
  const [racksDelNodo, setRacksDelNodo] = useState([]);

  const cargarRacks = useCallback(() => {
    if (!nodo?._id) return;
    axios
      .post("rack/selectRacksDeNodo", { nodoId: nodo._id }, { headers: headersToken })
      .then((res) => {
        if (res.data.success === 2) setRacksDelNodo(res.data.racks || []);
      })
      .catch((error) => console.error("Error al consultar los racks del nodo:", error));
  }, [nodo, headersToken]);

  useEffect(() => {
    if (visible) cargarRacks();
  }, [visible, cargarRacks]);

  if (!nodo) return null;

  return (
    <Drawer title={`${nodo.codigo}${nodo.nombre ? " - " + nodo.nombre : ""}`} visible={visible} onClose={onClose} width={360}>
      <div style={{ marginBottom: 16 }}>
        <div><strong>Tipo:</strong> {TIPOS_NODO[nodo.tipo] || nodo.tipo}</div>
        {nodo.bloqueado && (
          <Tag color="red" style={{ marginTop: 8 }}>Bloqueado (excluido de las rutas)</Tag>
        )}
      </div>
      <div style={{ fontWeight: 700, marginBottom: 8 }}>Racks que se alcanzan desde aquí ({racksDelNodo.length})</div>
      <List
        size="small"
        dataSource={racksDelNodo}
        locale={{ emptyText: "Ningún rack vinculado a este nodo" }}
        renderItem={(valorRack) => (
          <List.Item>{valorRack.codigo}{valorRack.nombre ? ` - ${valorRack.nombre}` : ""}</List.Item>
        )}
      />
    </Drawer>
  );
};

export default NodoDetalleDrawer;
